var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideosU2JRfHi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.082,
    height: 52.252,
    viewBox: "0 0 52.082 52.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.653 -0.505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.374,68.956V64.923H27.847v4.033H24.538a.861.861,0,1,0,0,1.723H35.683a.861.861,0,0,0,0-1.723Z",
    transform: "translate(-9.802 -27.425)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.964,21.035v7.478a7.958,7.958,0,0,0-6.187,2.947H.653V12.219A1.723,1.723,0,0,1,2.376,10.5H9.022a5.506,5.506,0,0,0-.033.6,5.388,5.388,0,0,0,3.724,5.122H11.77a5.894,5.894,0,0,0-5.812,4.912l-1.2,7.116a1.723,1.723,0,0,0,1.7,2.01H18.3a1.723,1.723,0,0,0,1.723-1.723v-4.9h1.267a5.3,5.3,0,0,0,3.67-1.475l1.172-1.124Zm-20.378-8.59v3.777H16.031A5.4,5.4,0,0,0,19.586,12.445Z",
    transform: "translate(0 -4.254)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 6.25,
    r: 6.25,
    transform: "translate(33.714 25.982)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.561,83.811a1.723,1.723,0,0,1-1.553-2.469,14.016,14.016,0,0,1,25.222.007,1.706,1.706,0,0,1-1.537,2.445c-5.142.017-16.99.017-22.131.017Z",
    transform: "translate(-19.663 -31.054)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.622,11.14V2.228A1.723,1.723,0,0,1,38.345.505H57.281A1.722,1.722,0,0,1,59,2.228V13.336a1.722,1.722,0,0,1-1.723,1.723H43.127a3.706,3.706,0,0,0-.372-4.624l-.042-.044a3.706,3.706,0,0,0-5.219-.087Zm16.692-.907H49.038a.861.861,0,0,0,0,1.723h4.277a.861.861,0,1,0,0-1.723Zm0-3.313H45.331a.861.861,0,1,0,0,1.723h7.983a.861.861,0,1,0,0-1.723Zm0-3.312H43.923a.861.861,0,0,0,0,1.723h9.391a.861.861,0,1,0,0-1.723Z",
    transform: "translate(-15.313)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.661,
    cy: 3.661,
    r: 3.661,
    transform: "translate(10.711 3.185)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,32.06a.877.877,0,0,1,.012-.144l.9-5.346a.861.861,0,0,1,1.7.287l-.88,5.2H22.6V25.435h2.99a3.577,3.577,0,0,0,2.477-1l2.348-2.253a1.984,1.984,0,0,0,.069-2.793l-.022-.024a1.983,1.983,0,0,0-2.793-.047l-2.236,2.144H16.07a4.172,4.172,0,0,0-4.113,3.476l-1.2,7.116Z",
    transform: "translate(-4.3 -7.777)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.707,50H.653v5.124a1.723,1.723,0,0,0,1.723,1.723H32.821A7.981,7.981,0,0,1,32.707,50ZM19.128,54.286h2.361a.861.861,0,1,0,0-1.723H19.128a.861.861,0,1,0,0,1.723Z",
    transform: "translate(0 -21.072)",
    fill: "#fffefe",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosU2JRfHi);
export default __webpack_public_path__ + "static/media/videos_u2JRfHI.682f98efd6db61d56005ffd4f6fc5510.svg";
export { ForwardRef as ReactComponent };